import React, { Component } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import config from '@config/index'
import InputMask from 'react-input-mask'
import ReCAPTCHA from 'react-google-recaptcha'
import styles from '@containers/payment/index.module.scss'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

const mapDispatchToProps = ({ payment }) => {
  return {
    ...payment
  }
}

const mapStateToProps = ({ payment }) => {
  return {
    ...payment
  }
}
class CardConnectWidget extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showForm: props.showForm,
      data: props.data,
      cardToken: '',
      capthceValue: '',
      apiStatus: '',
      feedbackDone: '',
      submitting: false,
      showIframe: props.showIframe,
      changeName: props.changeName
    }
    this.listenCardConnect = this.listenCardConnect.bind(this)
  }

  onChangeRecaptche(val) {
    this.setState({ capthceValue: val })
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.listenCardConnect)
  }

  async componentDidMount() {
    window.addEventListener('message', this.listenCardConnect)
  }

  listenCardConnect(event) {
    if (
      event &&
      event.data &&
      event.origin &&
      (event.origin.indexOf('https://fts-uat.cardconnect.com') === 0 ||
        event.origin.indexOf('https://fts.cardconnect.com') === 0)
    ) {
      const cardConnectEvent = JSON.parse(event.data)
      if (cardConnectEvent.cssLoaded) {
        this.setState({
          showIframe: true
        })
      }
      if (cardConnectEvent.message && cardConnectEvent.message.length) {
        this.setState({
          cardToken: cardConnectEvent.message
        })
      }
      if (cardConnectEvent.validationError && cardConnectEvent.validationError.length) {
        this.setState({
          cardToken: ''
        })
      }
    }
  }
  async handleSubmit(val) {
    this.setState({ submitting: true })
    const payload = val
    payload.card_token = this.state.cardToken ? this.state.cardToken : ''
    if (this.state.capthceValue) {
      await this.props.payNow(payload)

      if (this.props.paynowError) {
        this.setState({ apiStatus: 'Error' })
      } else {
        this.setState({ apiStatus: 'Success' })
      }
      this.setState({ submitting: false })
    } else alert(this.props.t('payments.confirm-you-are-not-a-robot'))
    this.props.onSubmit(this.state.apiStatus)
  }
  render() {
    console.log('Amount = ' + this.state.data.amount)
    const t = this.props.t
    return (
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        // enableReinitialize
        initialValues={{
          additionalData: {},
          form_uuid: this.state.data.form_uuid,
          card_token: '',
          expiry: '',
          cvv: '',
          postal: '',
          city: '',
          tip: '',
          address: '',
          name: ''
          // state:"",
        }}
        validationSchema={Yup.object().shape({
          expiry: Yup.string().required(t('payments.required')),
          cvv: Yup.string().required(t('payments.required')),
          postal: Yup.string().required(t('payments.required')),
          name: Yup.string().required(t('payments.required')),
          // state:Yup.string().required("Required"),
          card_token: this.state.cardToken ? null : Yup.string().required(t('payments.required'))
        })}
        onSubmit={this.handleSubmit.bind(this)}
        render={({ values, setFieldValue }) => {
          return (
            <Form className={`common-payment-widget-form pt-20 ${styles['add-transaction-form']}`}>
              <div
                style={{ backgroundColor: this.state.data.settings && this.state.data.settings.form_bg_color }}
                className="container-fluid p-20">
                <div className="row ">
                  <div className="col-12">
                    <h2
                      className="pb-10 border-bottom mb-10"
                      style={{ color: this.state.data.settings && this.state.data.settings.form_label_color }}>
                      {this.state.data.title}
                    </h2>
                  </div>

                  <div className="col-12">
                    <p className="mb-10 mt-5">{this.state.data.description}</p>
                    <span className="d-block mb-10">
                      {t('payments.amount-0')}
                      <strong>{`$${this.state.data.amount}`}</strong>
                    </span>
                  </div>
                  {this.state.data.form_data.map((item, index) =>
                    item.name === 'payment_block' ? (
                      <div className="col-12">
                        <div className="row ">
                          <div className="col-12">
                            <div className="form-group">
                              <label
                                className="label-text "
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                {t('payments.card-number')} <span className="star">*</span>
                              </label>
                              <ErrorMessage name="card_token" component="span" className="form-error" />
                              <div id="payment" className="card-iframe-group position-relative">
                                <div
                                  className={`${styles['card-loader']} ${
                                    this.state.showIframe ? styles['card-loader-hidden'] : ''
                                  } `}>
                                  <img
                                    className={`${styles['loader-img']}`}
                                    src="https://dufzo4epsnvlh.cloudfront.net/image/loader-dot.svg"
                                    alt="loader"
                                  />
                                  <input
                                    name="card"
                                    placeholder={t('payments.enter-card-number')}
                                    disabled
                                    className="form-control relative"
                                    style={{
                                      borderColor:
                                        this.state.data.settings && this.state.data.settings.form_border_color
                                    }}
                                  />
                                </div>
                                <iframe
                                  id="tokenFrame"
                                  ref={(ref) => (this.card = ref)}
                                  name="tokenFrame"
                                  title="tokenFrame"
                                  src={`${config.paymentCardConnectUrl}?&css=${encodeURIComponent(
                                    `.error{color:red;}input{height:44px;padding: 0 15px;border-radius: 4px;box-sizing:border-box;width:100%; border: solid 1px ${
                                      (this.state.data.settings && this.state.data.settings.form_border_color) ||
                                      '#dbe3eb'
                                    };font-size: 14px;outline:0;}body{margin:0;}`
                                  )}&invalidinputevent=true`}
                                  frameBorder="0"
                                  scrolling="no"
                                  height="44"
                                  width="100%"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-4">
                            <div className="form-group">
                              <label
                                className="label-text text-uppercase"
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                EXPIRATION
                              </label>
                              <span className="star text-danger">&nbsp;*</span>
                              <ErrorMessage name="expiry" component="span" className="form-error" />
                              <InputMask
                                style={{
                                  borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                }}
                                maskChar={null}
                                maskPlaceholder="MM/YYYY"
                                placeholder="MM/YYYY"
                                className="form-control"
                                mask={[
                                  /[0-3]/,
                                  values.expiry[0] === '3' ? /[0-1]/ : /[0-9]/,
                                  '/',
                                  /[2]/,
                                  /[0-9]/,
                                  /[0-9]/,
                                  /[0-9]/
                                ]}
                                value={values.expiry}
                                onChange={(event) => setFieldValue('expiry', event.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-4">
                            <div className="form-group">
                              <label
                                className="label-text text-uppercase"
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                CVV{' '}
                              </label>
                              <span className="star text-danger">&nbsp;*</span>
                              <ErrorMessage name="cvv" component="span" className="form-error" />
                              <InputMask
                                style={{
                                  borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                }}
                                maskChar={null}
                                maskPlaceholder=""
                                placeholder={t('payments.enter-cvv')}
                                className="form-control"
                                mask={'9999'}
                                value={values.cvv}
                                onChange={(event) => setFieldValue('cvv', event.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-4">
                            <div className="form-group">
                              <label
                                className="label-text text-uppercase"
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                ZIP{' '}
                              </label>
                              <span className="star text-danger">&nbsp;*</span>
                              <ErrorMessage name="postal" component="span" className="form-error" />
                              <InputMask
                                style={{
                                  borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                }}
                                maskChar={null}
                                maskPlaceholder=""
                                placeholder={t('payments.enter-zip')}
                                className="form-control"
                                mask={'999999999999999'}
                                value={values.postal}
                                onChange={(event) => setFieldValue('postal', event.target.value)}
                              />
                            </div>
                          </div>{' '}
                          {this.state.data && this.state.data.isAllowTip ? (
                            <div className="col-12 col-sm-6">
                              <div className="form-group">
                                <label
                                  className="label-text text-uppercase"
                                  style={{
                                    color: this.state.data.settings && this.state.data.settings.form_label_color
                                  }}>
                                  {t('payments.optional-tip')}{' '}
                                </label>
                                <Field
                                  style={{
                                    borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                  }}
                                  className="form-control form-control-lg"
                                  type="number"
                                  name="tip"
                                  placeholder={t('payments.optional-tip-1')}
                                />
                              </div>
                            </div>
                          ) : null}
                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label
                                className="label-text text-uppercase"
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                ADDRESS{' '}
                              </label>
                              <Field
                                style={{
                                  borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                }}
                                className="form-control form-control-lg"
                                type="text"
                                name="address"
                                placeholder={t('payments.enter-address')}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label
                                className="label-text text-uppercase"
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                NAME{' '}
                              </label>
                              <span className="star text-danger">&nbsp;*</span>
                              <ErrorMessage name="name" component="span" className="form-error" />
                              <Field
                                style={{
                                  borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                }}
                                className="form-control form-control-lg"
                                type="text"
                                name="name"
                                placeholder={t('payments.enter-name')}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <div className="form-group">
                              <label
                                className="label-text text-uppercase"
                                style={{
                                  color: this.state.data.settings && this.state.data.settings.form_label_color
                                }}>
                                CITY{' '}
                              </label>
                              <Field
                                style={{
                                  borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                                }}
                                className="form-control form-control-lg"
                                type="text"
                                name="city"
                                placeholder={t('payments.enter-city')}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : item.field_type === 'Multiline Text' ? (
                      <div className="col-12">
                        <div className="form-group">
                          <label
                            className="label-text text-uppercase"
                            style={{
                              color: this.state.data.settings && this.state.data.settings.form_label_color
                            }}>
                            {item.label}
                          </label>
                          {item.required ? <span className="star text-danger">&nbsp;*</span> : ''}

                          <Field
                            style={{
                              borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                            }}
                            className="form-control form-control-lg"
                            component="textarea"
                            placeholder={item.placeholder}
                            value={values.additionalData[item.name]}
                            onChange={(e) =>
                              this.addingFormDataDynamic(e.target.value, values, setFieldValue, item.name)
                            }
                            required={!!item.required}
                          />
                        </div>
                      </div>
                    ) : item.field_type === 'Input Field' ? (
                      <div className="col-12">
                        <div className="form-group">
                          <label
                            className="label-text text-uppercase"
                            style={{
                              color: this.state.data.settings && this.state.data.settings.form_label_color
                            }}>
                            {item.label}
                          </label>
                          {item.required ? <span className="star text-danger">&nbsp;*</span> : ''}
                          <Field
                            style={{
                              borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                            }}
                            className="form-control form-control-lg"
                            Component="text"
                            placeholder={item.placeholder}
                            value={values.additionalData[item.name]}
                            onChange={(e) =>
                              this.addingFormDataDynamic(e.target.value, values, setFieldValue, item.name)
                            }
                            required={!!item.required}
                          />
                        </div>
                      </div>
                    ) : item.field_type === 'Dropdown' ? (
                      <div className="col-12">
                        <div className="form-group">
                          <label
                            className="label-text text-uppercase"
                            style={{
                              color: this.state.data.settings && this.state.data.settings.form_label_color
                            }}>
                            {item.label}
                          </label>
                          {item.required ? <span className="star text-danger">&nbsp;*</span> : ''}
                          <select
                            style={{
                              borderColor: this.state.data.settings && this.state.data.settings.form_border_color
                            }}
                            className="form-control bg-white"
                            onChange={(e) =>
                              this.addingFormDataDynamicSelect(
                                e.target.value,
                                values,
                                setFieldValue,
                                item.name,
                                item.options
                              )
                            }
                            required={!!item.required}>
                            <option value="" disabled selected>
                              {item.placeholder}
                            </option>

                            {item.options && item.options.length > 0
                              ? item.options.map((optItem, i) => (
                                  <option key={i} value={optItem._id}>
                                    {optItem.label}
                                  </option>
                                ))
                              : null}
                          </select>
                        </div>
                      </div>
                    ) : null
                  )}
                </div>
                <ReCAPTCHA sitekey={config.googleReCAPTCHAKey} onChange={(val) => this.onChangeRecaptche(val)} />,
                <footer
                  className={
                    this.state.data && this.state.data.settings && this.state.data.settings.button_alignment === 'right'
                      ? 'text-right'
                      : this.state.data.settings.button_alignment === 'center'
                      ? 'text-center'
                      : 'text-left'
                  }>
                  <button
                    type="submit"
                    disabled={this.state.submitting}
                    className={`btn btn-lg border ${styles['create-button-width']}`}
                    style={{
                      backgroundColor:
                        this.state.data && this.state.data.settings && this.state.data.settings.button_color
                          ? this.state.data.settings.button_color
                          : '#ffffff',
                      color:
                        this.state.data && this.state.data.settings && this.state.data.settings.button_color
                          ? this.state.data.settings.button_text_color
                          : '#ffffff'
                    }}>
                    {this.state.data && this.state.data.settings && this.state.data.settings.button_label
                      ? this.state.data.settings.button_label
                      : 'PAY'}

                    {this.state.submitting ? (
                      <i className="btn-icon top-minus-2">
                        <img className="spinner" src="https://dufzo4epsnvlh.cloudfront.net/image/default.svg" alt="" />
                      </i>
                    ) : null}
                  </button>
                </footer>
              </div>
            </Form>
          )
        }}
      />
    )
  }
}

export default withTranslation()(compose(connect(mapStateToProps, mapDispatchToProps))(CardConnectWidget))
